import React, { Component } from 'react'
import { translate } from 'react-i18next'
import Error from './Error'
import Menu from './Menu'
import Spinner from './Spinner'

class VCWPCustomMenu extends Component {
  constructor(props) {
    super(props)
    this.state = {
      menu: null
    }

    if (props.menus[props.menuId] === undefined)
      props.getMenu(props.menuId)
  }

  static getDerivedStateFromProps(props, state) {
    if (props.menus[props.menuId] === undefined)
      return null

    return { menu: props.menus[props.menuId] }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.menuId !== prevProps.menuId)
      this.props.getMenu(this.props.menuId)
  }

  render() {
    if (this.state.menu !== null && this.state.menu.getCode() !== 200)
      return <Error>{this.props.t('err.loadingMenu')}</Error>

    if (this.state.menu === null)
      return <Spinner>{this.props.t('msg.loadingMenu')}</Spinner>

    return <Menu className={this.props.className} items={this.state.menu.getItems()} />
  }
}

export default translate()(VCWPCustomMenu)



// WEBPACK FOOTER //
// ./src/components/VCWPCustomMenu.js